import { render, staticRenderFns } from "./HowToReserve.vue?vue&type=template&id=8d534e3c&lang=pug&"
import script from "./HowToReserve.vue?vue&type=script&lang=js&"
export * from "./HowToReserve.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports